import React from "react";
import styles from "../../styles/components/pageNotFound.module.scss";
import pageNotFoundImg from "../../assets/pageNotFound.gif";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../ui/CustomButton/CustomButton";
import { Box } from "@mui/material";

 function PageNotFound() {
  const navigate = useNavigate()

  const redirectToHome =()=>{
    navigate("/")
  }
  return (
    <div 
    className={styles.not_found_container}
    >
    <div 
    className={styles.not_found_cont}
    >
      <figure>
          <img src={pageNotFoundImg} alt="" />
      </figure>
    
     <Box>
       <CustomButton type='button' onClick={redirectToHome}>Back To Home</CustomButton>
     </Box>
      
    </div>
  </div>
  );
}
export default PageNotFound;